<template>
  <div id="public">
    <el-container>
      <el-header>
        <div class="header">
          <div style="display: flex; height: 60px; line-height: 60px; cursor:pointer;margin-right: 200px;">
            <img :src="staticImages.logo" style="height: 100%;margin-right: 20px" alt=""/>
            <h1>综检联网平台</h1>
          </div>
          <el-menu default-active="report" :router="true" background-color="#1A56A8" text-color="#fff"
                   active-text-color="#ffd04b"
                   class="el-menu-demo" mode="horizontal">
            <el-menu-item index="report">检车报告查询</el-menu-item>
            <!--                        <el-menu-item index="applicant">检测站接入</el-menu-item>-->
            <el-menu-item index="announcement">通知公告</el-menu-item>
          </el-menu>
        </div>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
      <el-footer style="height: 100px; background: #eee; font-size: 14px;">
        <div
            style="width: 600px;margin:0 auto;padding: 20px 0 0;text-align: center;display: flex;flex-direction: row; justify-content: center">
          <div style="padding-right: 20px; border-right: 1px solid #ccc">
            <a target="_blank" href="http://www.mot.gov.cn/" style="display:inline-block;text-decoration: none;">
              <img :src="staticImages.jiaotongting" style="height:36px" alt="">
            </a>
          </div>
          <div style="padding-left: 20px">
            <a target="_blank" href="http://jtyst.nmg.gov.cn/" style="display:inline-block;text-decoration: none;">
              <img :src="staticImages.gonganbu" style="height:36px" alt="">
            </a>
          </div>
        </div>
        <div
            style="width: 100%;margin:0 0 10px 0;padding: 10px 0 0;text-align: center; display: flex;flex-direction: row; justify-content: center">
          <div style="padding-right: 10px; border-right: 1px solid #ccc">
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32021402001118"
               style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
              <img :src="staticImages.gongan" style="float:left;">
              <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">苏公网安备
                32021402001118号</p>
            </a>
          </div>
          <div style="padding: 0 10px;">©2019&nbsp;<a href="http://www.qichezongjian.com/detect/" target="_blank">无锡爬山虎网络科技有限公司版权所有</a>
          </div>
          <div style="padding-left: 10px; border-left: 1px solid #ccc"><a href="https://beian.miit.gov.cn">ICP备案号&nbsp;苏ICP备19010855号</a>
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'public',
  data() {
    return {
      staticImages: {
        jiaotongting: require('../assets/2804.png'),
        gonganbu: require('../assets/2805.png'),
        gongan: require('../assets/gongan.png'),
        logo: require('../assets/logo-white.png')
      },
      activeIndex: 'report'
    }
  },
  components: {},
  created() {
  },
  mounted: function () {
    this.activeIndex = this.$route.path.replace('/home/', '')
  },
  methods: {}
}
</script>

<style scoped lang="stylus">
#public {
  .el-header {
    height: 60px;
    background-color: #1A56A8
    position: fixed;
    top: 0
    width: 100%;
    z-index: 1000

    .header {
      height: 60px;
      line-height: 60px;
      display flex;
      flex-direction row

      h1 {
        height: 60px;
        line-height 60px;
        padding: 0;
        margin: 0;
        color: #fff;
      }
    }
  }

  .el-main {
    min-height: calc(100vh - 162px);
    margin-top: 60px;
  }
}
</style>

<style lang="stylus">
#public {
  .el-menu.el-menu--horizontal {
    border-bottom none
  }
}
</style>